var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "open-salud-about" },
    [
      _c(
        "v-row",
        { staticClass: "row container-assistance" },
        [
          _c(
            "v-col",
            {
              staticClass: "main-container-text px-lg-16 my-auto lowpadding",
              attrs: { sm: "12" }
            },
            [
              _c("h3", {
                staticClass: "title-discount title-discount2",
                domProps: { innerHTML: _vm._s(_vm.$t("secondblock.title")) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "carousel-container" }, [
                _c("div", { staticClass: "carousel-inner" }, [
                  _c(
                    "div",
                    { staticClass: "track" },
                    [
                      _vm._l(_vm.cards, function(card) {
                        return _c(
                          "div",
                          { key: card.title, staticClass: "card-container" },
                          [
                            _c(
                              "v-col",
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "priceshadowsmall p-3" },
                                  [
                                    _c("v-col", { attrs: { cols: "12" } }, [
                                      _c("p", { staticClass: "title-offers" }, [
                                        _vm._v(_vm._s(card.title))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", md: "6" } },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "price-befores"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(card.priceBefore)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "subtitle-offer-1s"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "secondblock.subtitle-offer-1-1"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", md: "6" } },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "price-afters"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(card.priceAfter) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "asterisk"
                                                      },
                                                      [_vm._v("(*)")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "subtitle-offer-2s"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "secondblock.subtitle-offer-1-2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-col", { attrs: { cols: "12" } }, [
                                      _c(
                                        "p",
                                        { staticClass: "subtitle-offer-3s" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "secondblock.subtitle-offer-1-3",
                                                { price: card.saveAmount }
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-container" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "height-100" },
                            [
                              _c(
                                "v-row",
                                { staticClass: "priceshadowsmall height-100" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ismobile",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("p", { staticClass: "title-offers" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("secondblock.title-offer-7")
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "p",
                                      { staticClass: "subtitle-fullheight" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "secondblock.subtitle-offer-7-3"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nav button-line",
                    staticStyle: { position: "relative" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "prev",
                        staticStyle: {
                          "background-color": "transparent",
                          "border-color": "transparent",
                          transform: "rotate(-180deg)"
                        }
                      },
                      [
                        _c(
                          "i",
                          { staticClass: "prev" },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "black"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "next",
                        staticStyle: {
                          "background-color": "transparent",
                          "border-color": "transparent",
                          transform: "rotate(-0deg)"
                        }
                      },
                      [
                        _c(
                          "i",
                          { staticClass: "next" },
                          [
                            _c("base-icon", {
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                color: "black"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("v-row"),
              _vm._v(" "),
              _c("v-row"),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        xs: "12",
                        sm: "12",
                        md: "12",
                        lg: "12",
                        xl: "12"
                      }
                    },
                    [
                      _c("p", { staticClass: "asterisk-text" }, [
                        _vm._v(_vm._s(_vm.$t("secondblock.asterisk-text")))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass:
                "main-container-text px-lg-16 my-auto column-invert heightautos desktopnone",
              attrs: { sm: "12" }
            },
            [
              _c("h3", { staticClass: "title-discount-invert" }, [
                _vm._v(_vm._s(_vm.$t("secondblock.titleInvert")))
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "subtitle-discount-invert" }, [
                _vm._v(_vm._s(_vm.$t("secondblock.subtitleInvert")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle-list subtitle-list mt-sm-5 iconlist" },
                [
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle1")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle2")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle3")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle4")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle5")))
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "p",
                      [
                        _c("v-icon", {
                          attrs: { large: "" },
                          domProps: { textContent: _vm._s("mdi-monitor") }
                        }),
                        _vm._v(_vm._s(_vm.$t("secondblock.iconTitle6")))
                      ],
                      1
                    )
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7463044a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7463044a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PrimesaludDiscountsSecondBlock.vue
// module id = 4203
// module chunks = 42